'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDocumentMeta = require('react-document-meta');

var _reactDocumentMeta2 = _interopRequireDefault(_reactDocumentMeta);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventMeta = function EventMeta(_ref) {
  var event = _ref.event,
      siteName = _ref.siteName,
      twitterUsername = _ref.twitterUsername;

  var descriptionPlainText = event.description.replace(/<[^>]*>/g, ' ').replace(/[\s\r]+/g, ' ').trim();
  var meta = {
    title: event.title,
    description: descriptionPlainText,
    meta: {
      charSet: 'utf-8',
      property: {
        'og:site_name': siteName,
        'og:image': event.photo_url,
        'og:locale': 'fr_CA',
        'og:title': event.title,
        'og:description': descriptionPlainText,
        'twitter:card': 'summary',
        'twitter:site': twitterUsername,
        'twitter:creator': twitterUsername,
        'twitter:title': event.title,
        'twitter:description': descriptionPlainText,
        'twitter:image': event.photo_url,
        'twitter:image:width': '200',
        'twitter:image:height': '200'
      }
    }
  };

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(_reactDocumentMeta2.default, meta)
  );
};

EventMeta.propTypes = {
  /**
   * Event object in the Caligram API format.
   */
  event: _propTypes2.default.object.isRequired,
  /**
   * The name of the website for `og:site_name`
   */
  siteName: _propTypes2.default.string,
  /**
   * The Twitter username to be used for `twitter:site` and `twitter:creator`
   */
  twitterUsername: _propTypes2.default.string
};

EventMeta.defaultProps = {
  twitterUsername: ''
};

exports.default = EventMeta;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/EventMeta.js
// module id = 272
// module chunks = 0